import { FC, ReactNode } from "react";

import { Box } from "@mui/material";
import { SearchBar } from "@rubi/ui";

export interface SubmissionsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  actions?: ReactNode;
}

const SubmissionsToolbar: FC<SubmissionsToolbarProps> = ({
  search,
  onSearchChange,
  searchPlaceholder = "Search",
  actions,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 2,
        // Matches the Reports/Alerts/Registries search row: 70% on desktop.
        maxWidth: { xs: "100%", md: "70%" },
      }}
    >
      <SearchBar
        value={search}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
        maxWidth="none"
      />
      {actions}
    </Box>
  );
};

export default SubmissionsToolbar;
